module.exports = "/images/approve_cancel-white.svg?3eab02334e86f0408f6a6bbf5c146728";